export const ro = {
  "nav.check_booking": "Verifică Rezervarea",
  "nav.admin": "Admin",
  "nav.book_now": "Rezervă Acum",
  "nav.driver": "Șofer",
  "hero.badge": "Transport pentru Studenți J1",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Transportul Tău de Încredere din Chicago spre Wisconsin",
  "hero.description": "Transport sigur, fiabil și accesibil pentru studenții cu viză J1. Rezervă-ți transferul azi!",
  "hero.book_trip": "Rezervă Călătoria",
  "hero.check_status": "Verifică Statusul Rezervării",
  "pricing.title": "Prețuri Transport",
  "pricing.subtitle": "Toate prețurile în USD",
  "pricing.ohare_mke": "Transfer (O'Hare / Milwaukee)",
  "pricing.midway": "Transfer (Midway)",
  "pricing.madison": "Madison spre Wisconsin Dells",
  "pricing.return": "Reducere pentru Retur",
  "pricing.shared": "Cursă Partajată",
  "pricing.private": "Cursă Privată",
  "pricing.per_person": "per persoană",
  "pricing.after_deposit": "cu depozit de $20",
  "pricing.without_deposit": "fără depozit",
  "pricing.flat_rate": "tarif fix",
  "pricing.per_suitcase": "Per bagaj",
  "pricing.carry_on": "Bagaj de mână",
  "pricing.free": "GRATUIT",
  "pricing.with_shipping": "Retur + expediere cu noi",
  "pricing.special_deal": "Ofertă Specială!",
  "pricing.midway_contact": "Contactați-ne pentru prețuri Midway (MDW)",
  "pricing.waterpark_note": "Prețurile pot diferi pentru Three Bears Water Park sau alte destinații.",
  "pricing.contact_us": "Contactați-ne",
  "pricing.guidelines_title": "Cum Funcționează Prețurile Noastre",
  "pricing.guidelines_deposit": "Un depozit de $20 per persoană îți asigură rezervarea. Restul se plătește în ziua călătoriei.",
  "pricing.guidelines_shared": "2 sau mai mulți pasageri care călătoresc în aceeași zi la același aeroport primesc tariful de cursă partajată.",
  "pricing.guidelines_solo": "Pasagerii singuri (singurul pasager în acea zi) pot avea un tarif ușor mai mare.",
  "pricing.guidelines_suitcase": "1 bagaj inclus gratuit la cursele de retur. Fiecare bagaj suplimentar costă $5.",
  "pricing.guidelines_payment": "Acceptăm plăți cu Card, Numerar și Zelle.",
  "requirements.title": "Cerințe pentru Rezervare",
  "requirements.pickup": "Oferim transferuri de două ori în 24 de ore, cu excepția cazului în care se notifică altfel. Planificați și rezervați din timp!",
  "requirements.deposit": "Este necesar un depozit nerambursabil de $3.200 JMD (sau $20 USD) înainte de a fi adăugat la program.",
  "requirements.seamless": "Asigurați-vă locul făcând depozitul în avans pentru a evita întârzierile.",
  "requirements.final_payment": "Soldul rămas trebuie achitat înainte de a urca în vehicul.",
  "special.title": "Destinația Nu Este Listată?",
  "special.description": "Oferim curse speciale către destinații în afara rutelor noastre regulate. Contactați-ne pentru o ofertă!",
  "special.call": "Sună",
  "special.whatsapp": "WhatsApp",
  "features.title": "De Ce Easy Transportation?",
  "features.subtitle": "De încredere pentru mii de studenți J1 în fiecare vară",
  "features.easy_booking": "Rezervare Ușoară",
  "features.easy_booking_desc": "Este necesar doar un depozit de $3.200 JMD ($20 USD). Plătiți prin transfer, card, PayPal sau Zelle.",
  "features.safe": "Sigur și Fiabil",
  "features.safe_desc": "Șoferi profesioniști, vehicule confortabile și suport 24/7 pentru studenți J1.",
  "features.flexible": "Program Flexibil",
  "features.flexible_desc": "Rezervă curse de sosire și retur. Primul bagaj gratuit la retur!",
  "video.badge": "Vedeți-ne în Acțiune",
  "video.title": "Călătoria Ta Începe Aici",
  "video.subtitle": "Urmărește studenții J1 din Jamaica și Republica Dominicană începându-și aventura",
  "video.book_now": "Rezervă Călătoria Acum",
  "booking.title": "Rezervă Călătoria",
  "booking.step": "Pasul",
  "booking.of": "din",
  "booking.trip_type": "Tipul Călătoriei",
  "booking.arrival": "Sosire (Transfer Aeroport)",
  "booking.return": "Retur (Spre Aeroport)",
  "booking.ride_type": "Tipul Serviciului",
  "booking.shared_ride": "Cursă Partajată",
  "booking.shared_desc": "Partajează cu alți pasageri pe aceeași rută",
  "booking.private_ride": "Cursă Privată",
  "booking.private_desc": "Vehicul exclusiv doar pentru tine",
  "booking.pickup_location": "Aeroportul de Plecare",
  "booking.select_airport": "Selectează Aeroportul",
  "booking.travel_date": "Data Călătoriei",
  "booking.travel_time": "Ora Estimată de Sosire",
  "booking.departure_time": "Ora de Plecare",
  "booking.flight_number": "Numărul Zborului",
  "booking.airline": "Compania Aeriană",
  "booking.terminal": "Terminalul de Sosire",
  "booking.full_name": "Numele Complet",
  "booking.whatsapp": "Număr WhatsApp",
  "booking.email": "Adresă de Email",
  "booking.housing": "Unitate de Cazare",
  "booking.select_housing": "Selectează Cazarea",
  "booking.custom_address": "Introduceți Adresa Personalizată",
  "booking.num_passengers": "Număr de Pasageri",
  "booking.suitcases": "Total Bagaje",
  "booking.shipping": "Folosiți T&M Courier Services?",
  "booking.payment": "Metoda de Plată",
  "booking.referral": "Cod de Recomandare",
  "booking.next": "Înainte",
  "booking.previous": "Înapoi",
  "booking.submit": "Finalizează Rezervarea",
  "booking.processing": "Se procesează...",
  "booking.start_over": "Începe din Nou",
  "booking.first_time": "Prima Călătorie",
  "booking.returning": "Client Care Revine",
  "booking.confirmation_number": "Număr de Confirmare",
  "pricing_summary.title": "Rezumatul Prețurilor",
  "pricing_summary.trip_price": "Prețul Călătoriei",
  "pricing_summary.luggage_fee": "Taxa de Bagaj",
  "pricing_summary.deposit": "Depozit",
  "pricing_summary.per_person": "per persoană",
  "pricing_summary.discount": "Reducere Recomandare",
  "pricing_summary.total_now": "Total de Plată Acum",
  "pricing_summary.balance": "Sold Rămas",
  "success.title": "Rezervare Confirmată!",
  "success.confirmation": "Număr de Confirmare",
  "success.details": "Detalii Rezervare",
  "success.whatsapp_optin": "Primiți actualizări prin WhatsApp",
  "success.home": "Înapoi la Pagina Principală",
  "driver.title": "Panoul Șoferului",
  "driver.login": "Acces Șofer",
  "driver.phone": "Număr de Telefon",
  "driver.pin": "Cod PIN",
  "driver.sign_in": "Autentifică-te",
  "driver.trips_today": "Cursele de Azi",
  "driver.upcoming": "Curse Viitoare",
  "driver.passengers": "pasageri",
  "driver.suitcases": "bagaje",
  "driver.navigate": "Navighează la Punct de Preluare",
  "driver.contact": "Contactează Pasagerul",
  "driver.complete": "Finalizează Cursa",
  "driver.logout": "Deconectare",
  "driver.no_trips": "Nu sunt curse programate",
  "common.loading": "Se încarcă...",
  "common.error": "Ceva a mers greșit",
  "common.save": "Salvează",
  "common.cancel": "Anulează",
  "common.close": "Închide",
  "common.details": "Detalii",
  "common.status": "Status",
  "common.date": "Data",
  "common.time": "Ora",
  "common.price": "Preț",
  "common.passenger": "Pasager",
  "common.passengers": "Pasageri",
};
